import { CatalystSubcategories } from '@api';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import {
  DRAWER_PARAM_KEYS,
  getCleanDrawerParams,
  queryKeys,
  queryValues,
} from '@terminal/routes/query-params';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';

export type MarketCatalystDrawerParams = {
  type: CatalystSubcategories;
  themeId?: string;
  insightId: string;
  source: PosthogTrackingSource;
};

export const useMarketCatalystDrawer = () => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const { trackCatalystDrawerOpen } = usePosthogEvents();

  const openDrawer = (drawerParams: MarketCatalystDrawerParams) => {
    trackCatalystDrawerOpen({
      source: drawerParams.source,
      type: 'market',
      insightId: drawerParams.insightId,
      themeIds: drawerParams.themeId ? [drawerParams.themeId] : undefined,
    });

    setQueryParams({
      ...getCleanDrawerParams(),
      [queryKeys.activeDrawer]: queryValues.marketCatalystDrawer,
      [queryKeys.type]: drawerParams.type,
      [queryKeys.themeId]: drawerParams.themeId,
      [queryKeys.insightId]: drawerParams.insightId,
    });
  };

  const closeDrawer = () => {
    deleteQueryParam([...DRAWER_PARAM_KEYS, queryKeys.drawerExpanded]);
  };

  const isOpen = params.activeDrawer === queryValues.marketCatalystDrawer;

  return {
    closeDrawer,
    openDrawer,
    isOpen,
    drawerType: params[queryKeys.type],
    themeId: params[queryKeys.themeId],
    insightId: params[queryKeys.insightId],
    utmSource: params[queryKeys.utmSource],
  };
};
